<template>
  <div class="m-activity-buyTicketRecord">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="120" >
        <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #entryTime="{ row }">
        <span>{{ row.startTime ? $moment(row.startTime).format('YYYY/MM/DD HH:mm') : '' }}</span>
        <span> - </span>
        <span>{{ row.endTime ? $moment(row.endTime).format('YYYY/MM/DD HH:mm') : '' }}</span>
      </template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #status="{ row }">{{ statusMap[row.status] }}</template>
      <template #type="{ row }">{{ row.type }}</template>
      <template #buyTime="{ row }">{{ row.buyTime ? $moment(row.buyTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #operation="{ scope }">
        <el-button v-if="scope.row.status == 'New'" type="text" @click="onUnPaid(scope.row, scope.$index)">退款</el-button>
      </template>
    </Table>

    <Dialog :dialogShow="dialogShow" title="退款" @maskClick="maskClick">
      <template>
        <el-form class="refundForm" label-position="right" label-width="100px">
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="可退款金额">
                <span class="desc-refund">{{ row.amount ? row.amount:0 }}元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="可退款积分">
                <span class="desc-refund">{{ row.point ? row.point:0 }}积分</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="btn-row">
            <el-button class="login-btn" type="default" @click="maskClick">
              取消
            </el-button>
            <el-button type="primary" @click="confirm" :loading="refundLoading">
              确认
            </el-button>
          </el-row>
        </el-form>
      </template>

    </Dialog>

  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getApplyTicketBuyRecord,api_getTicketBoughtExportRecord, api_getRefund,api_getRefundPoint } from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import Table from "@/components/Table/index";
import Search from "@/components/Search/index";
import { downFile } from "@/utils";
import Dialog from '@/components/Dialog/index'


export default {
  name: "marketActivityListIndex",
  components: {
    AuthButton,
    Table,
    Search,
    Dialog
  },
  props: {
  },
  data() {
    return {
      form: {},
      tableKey: false,
      exportLoading:false,
      dialogShow: false,
      refundLoading: false,
      row: {},
      renderData: [
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "购票时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "buyTime",
          valueFormat: 'timestamp'
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          key: "status",
          option: [
            { label: "未核销", value: 'New', },
            { label: "已核销", value: 'Used', },
            { label: "已退款", value: 'Refund', },
            { label: "已取消", value: 'Cancel', },
            { label: "待支付", value: 'UnPaid', }
          ],
        },
      ],
      tableThData: [
        { prop: "name", label: "票名称", minWidth: "180", },
        { prop: "entryTime", label: "入场时间", minWidth: "230", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "status", label: "状态", minWidth: "100", },
        { prop: "type", label: "类型", minWidth: "100", },
        { prop: "buyTime", label: "购票时间", minWidth: "180", },
        { prop: "source", label: "来源", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      statusMap: {
        'New': '未核销',
        'Used': '已核销',
        'UnPaid': '待支付',
        'Refund': '已退款',
        'Cancel':'已取消',
        'Free':'未核销'
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      params.startBuyTime = this.form.buyTime ? this.form.buyTime[0] : ''
      params.endBuyTime = this.form.buyTime ? this.form.buyTime[1] : ''
      delete params.buyTime
      try {
        const data = await api_getApplyTicketBuyRecord(params)
        console.log('data: ', data);
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },
    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
      }
      params.startBuyTime = this.form.buyTime ? this.form.buyTime[0] : ''
      params.endBuyTime = this.form.buyTime ? this.form.buyTime[1] : ''
      delete params.buyTime
      let res = await api_getTicketBoughtExportRecord(params)
      downFile(res)
      this.exportLoading = false
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },
  
    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    },

    //退款
    onUnPaid(row, index) {
      this.dialogShow = true
      this.row = row
    },
    confirm() {
      this.$baseConfirm(
        '退款为敏感操作，请再次核对是否操作退款？',
        {
          title: '温馨提示',
          type: 'warning',
          cancelButtonText: '取消退款',
          confirmButtonText: '确认退款',
        },
        async () => {
          this.confirmOk()
        }
      )
    },
    async confirmOk() {
      this.refundLoading = true
      try {
        this.row.type == '积分参与' ?  await api_getRefundPoint({ ticketId: this.row.id }):await api_getRefund({ payId: this.row.payId, amount: this.row.amount })
        //组合退款
        // await api_getRefund({ payId: this.row.payId, amount: this.row.amount })
        // //积分退款
        // await api_getRefundPoint({ ticketId: this.row.id })
        this.$baseMessage('退款成功', 'success')
        this.refundLoading = false
        this.maskClick()
        this.getList()
      } catch (error) {
        this.refundLoading = false
      }
    },
    maskClick() {
      this.row = {}
      this.dialogShow = false
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-buyTicketRecord {
  box-sizing: border-box;
}

.refundForm {
  margin-top: 30px;
  padding-right: 20px;
  box-sizing: border-box;

  .desc-refund {
    font-size: 16px;
    font-weight: 600;
    color: #FF6969;
  }

  .btn-row {
    padding-top: 20px;
    float: right;
    overflow: hidden;
    box-sizing: border-box;

    .el-button+.el-button {
      margin-left: 20px;
    }

    button {
      border: 0;
      width: 110px;
      height: 34px;
      padding: 0;
      line-height: 34px;
      text-align: center;
      font-size: 16px;
    }
  }

  ::v-deep {
    .el-input {
      border-radius: 2px;
      font-size: 16px;

      .el-input__inner {
        background: #F2F3F5;
      }

      .el-input__inner:focus {
        background: #fff;
        border: 1px solid #05C8AF;
      }
    }

    .el-input.is-focus {
      .el-input__inner {
        background: #fff;
      }
    }
  }
}
</style>
